import { graphql } from '../gql/index.ts';
import { useQuery } from 'urql';
import { SeminarCard } from './SeminarCard.tsx';
import { usePublicCompany } from './hooks/usePublicCompany.ts';
import { getFormattedSeminarDate } from './util.ts';
import { ErrorPage } from './ErrorPage.tsx';
import { PublicProfileSidebar } from './PublicProfileSidebar.tsx';

const MySeminarsQuery = graphql(/* GraphQL */ `
  query getMySeminars($companyId: String!) {
    mySeminars(companyId: $companyId) {
      seminars {
        id
        title
        subtitle
        seminarNumber
        dateText
        description
        plainDescription
        locationText
        startDate
        endDate
        lecturers {
          name
        }
        categories {
          name
        }
      }
      count
    }
  }
`);

interface MySeminarListProps {
  companyId: string;
}

export const MySeminarList: React.FC<MySeminarListProps> = ({ companyId }) => {
  const [mySeminarsQueryResult] = useQuery({
    query: MySeminarsQuery,
    variables: {
      companyId,
    },
    pause: companyId === undefined || companyId === null,
  });
  const { data } = mySeminarsQueryResult;
  const { mySeminars } = data || {};
  const [publicCompany] = usePublicCompany();

  const showSidebar =
    publicCompany?.functionalSettings?.searchActive ||
    Boolean(publicCompany?.sites?.length) ||
    Boolean(publicCompany?.categories?.length);

  return (
    mySeminarsQueryResult.data && (
      <>
        <PublicProfileSidebar />
        <div
          className={`${showSidebar ? 'md:col-span-9 md:col-start-4' : 'md:col-span-12'} col-span-1 flex flex-col gap-4`}
        >
          <h2>
            Meine Seminare
            {`${mySeminars?.count ? ` (${mySeminars?.count})` : ''}`}
          </h2>
          {mySeminars?.count ? (
            mySeminars.seminars?.map((seminar) => {
              return (
                <SeminarCard
                  key={seminar?.id}
                  instructors={
                    seminar?.lecturers
                      ?.map((lecturer) => lecturer.name)
                      .filter(Boolean) as string[]
                  }
                  id={seminar?.seminarNumber}
                  title={seminar?.title}
                  time={getFormattedSeminarDate(
                    seminar.startDate,
                    seminar.endDate,
                    seminar.dateText,
                  )}
                  description={seminar?.plainDescription}
                  subtitle={seminar?.subtitle}
                  location={seminar?.locationText}
                  category={
                    seminar?.categories?.find((c) => Boolean(c.name.trim()))
                      ?.name
                  }
                  titleLink={'/seminar/' + seminar?.id}
                />
              );
            })
          ) : (
            <ErrorPage text="Keine Seminare gefunden" />
          )}
        </div>
      </>
    )
  );
};
